import { NavLink } from "react-router-dom";
import { Home, Compass, Download, Heart, User } from "lucide-react";

const items = [
  { to: "/", icon: Home, label: "Accueil", testid: "nav-accueil", end: true },
  { to: "/explorer", icon: Compass, label: "Explorer", testid: "nav-explorer" },
  { to: "/hors-ligne", icon: Download, label: "Hors-ligne", testid: "nav-hors-ligne" },
  { to: "/favoris", icon: Heart, label: "Mes favoris", testid: "nav-favoris" },
  { to: "/compte", icon: User, label: "Mon compte", testid: "nav-compte" },
];

export const BottomNav = () => (
  <nav data-testid="bottom-nav"
    className="shrink-0 z-40 border-t border-border bg-background/95 backdrop-blur-md pb-[env(safe-area-inset-bottom)]">
    <div className="max-w-6xl mx-auto grid grid-cols-5">
      {items.map((it) => (
        <NavLink key={it.to} to={it.to} end={it.end} data-testid={it.testid}
          className={({ isActive }) =>
            `flex flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition-colors ${
              isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
            }`
          }>
          {({ isActive }) => (
            <>
              <it.icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 2} />
              {it.label}
            </>
          )}
        </NavLink>
      ))}
    </div>
  </nav>
);
